import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives";

type Nullable<T> = T | null;

export interface HeroIntroProps {
    title?: Nullable<string>;
    subtitle?: Nullable<string>;
    alignment?: "center" | "left";
}

export const HeroIntro = ({ title, subtitle, alignment }: HeroIntroProps) => {
    const heroContainer = css({
        textAlign: alignment,
        gridTemplateColumns: "repeat(12, 1fr)",
        display: "grid",
        columnGap: "24px",
        [media.above.md]: {
            gridTemplateColumns: "repeat(12, minmax(0, 1fr))",
            columnGap: "32px"
        }
    });

    const textCss = css({
        marginBlockEnd: "0",
        gridColumn: "1 / span 12",
        [media.above.md]: {
            gridColumn: `${alignment == "center" ? "2" : "1"} / span 10`
        }
    });

    return (
        <div css={heroContainer}>
            <h1 css={textCss}>{title}</h1>
            {subtitle && (
                <p css={textCss} className="body-lg">
                    {subtitle}
                </p>
            )}
        </div>
    );
};
